import { signalingContentWhiteboardLaserUpdated } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

export function* onContentWhiteboardLaserUpdatedSaga(
  action: ReturnType<typeof signalingContentWhiteboardLaserUpdated>
) {
  const { id, userId, data, page } = action.payload;

  if (contentBoard.type !== 'file' || contentBoard.id !== id) {
    return;
  }

  try {
    const parsedData = JSON.parse(data);

    yield call(contentBoard.updateRemoteLaserPointer, { id, userId, page, data: parsedData });
  } catch (error) {
    Sentry.captureException(error);
  }
}
